'use client';

import { c as _c } from "react/compiler-runtime";
import { createSuggestion } from '@/app/_shared/suggestion/actions';
import Comment from '@mui/icons-material/Comment';
import DeleteForever from '@mui/icons-material/DeleteForever';
import Send from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Modal } from '@/app/_shared/components/Modal';
import { useToast } from '@/app/_shared/components/ToastContext';
import { ToastType } from '@/app/_shared/enums';
import { useServerHandler } from '@/app/_shared/hooks/userServerHandler';
import { useState } from 'react';
const CHARACTER_LIMIT = 400 as const;
export const SuggestionButton: React.FC = () => {
  const $ = _c(34);
  const {
    pushToast
  } = useToast();
  const {
    doServerAction,
    isLoading
  } = useServerHandler();
  const [isOpen, setOpen] = useState(false);
  const [comment, setComment] = useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setOpen(false);
      setComment("");
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const closeModal = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpen(true);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const openModal = t1;
  let t2;
  if ($[2] !== comment || $[3] !== doServerAction || $[4] !== pushToast) {
    t2 = function handleSendSuggestion() {
      doServerAction(() => createSuggestion(comment.trim()), () => {
        pushToast({
          message: "Suggestion sent!",
          type: ToastType.SUCCESS
        });
        closeModal();
      });
    };
    $[2] = comment;
    $[3] = doServerAction;
    $[4] = pushToast;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleSendSuggestion = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Button variant="outlined" endIcon={<Comment />} color="info" onClick={openModal} size="large">Send Suggestion</Button>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== comment || $[8] !== isLoading) {
    t4 = isLoading || !comment.trim();
    $[7] = comment;
    $[8] = isLoading;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Send />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== handleSendSuggestion || $[12] !== t4) {
    t6 = <Button disabled={t4} onClick={handleSendSuggestion} endIcon={t5} variant="contained">Send</Button>;
    $[11] = handleSendSuggestion;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e => setComment(e.target.value);
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      maxLength: CHARACTER_LIMIT
    };
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = !comment.length;
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      mt: "auto"
    };
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setComment("");
    t12 = <DeleteForever />;
    $[17] = t11;
    $[18] = t12;
  } else {
    t11 = $[17];
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t9) {
    t13 = {
      endAdornment: <IconButton disabled={t9} sx={t10} color="error" size="small" onClick={t11}>{t12}</IconButton>
    };
    $[19] = t9;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = comment.length === CHARACTER_LIMIT ? "secondary" : "green";
  const t15 = `${comment.length}/${CHARACTER_LIMIT}`;
  let t16;
  if ($[21] !== t14 || $[22] !== t15) {
    t16 = <Typography fontSize={12} fontWeight={600} textAlign="end" display="block" component="span" color={t14}>{t15}</Typography>;
    $[21] = t14;
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  const t17 = comment.length === CHARACTER_LIMIT ? "warning" : "primary";
  let t18;
  if ($[24] !== comment || $[25] !== t13 || $[26] !== t16 || $[27] !== t17) {
    t18 = <TextField fullWidth={true} required={true} autoFocus={true} multiline={true} rows={6} margin="dense" onChange={t7} value={comment} label="Write a suggestion" inputProps={t8} InputProps={t13} helperText={t16} color={t17} />;
    $[24] = comment;
    $[25] = t13;
    $[26] = t16;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== isLoading || $[30] !== isOpen || $[31] !== t18 || $[32] !== t6) {
    t19 = <>{t3}<Modal isOpen={isOpen} onClose={closeModal} title="Send Us A Suggestion" fullWidth={true} actions={t6} isLoading={isLoading}>{t18}</Modal></>;
    $[29] = isLoading;
    $[30] = isOpen;
    $[31] = t18;
    $[32] = t6;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  return t19;
};